module.exports = __webpack_public_path__ + "img/studyportals-logo-transparant.db225683.png";